var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"blogView"}},[(_vm.isLoading)?_c('LoadingSpinnerOverlay'):_vm._e(),_c('router-view'),_c('div',{staticClass:"d-flex pb-2"},[_c('TPWidgetCarousel')],1),_c('div',{staticClass:"container"},[_c('HomeCategories')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }